export enum Scope {
  AppContext = "AppContext",
  Experiments = "Experiments",
  Navigation = "Navigation",
  Auth = "Auth",
}
